import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsWin extends Decision {
    public evaluate() {
        const isWin = GameState.currentRecordHasSymbolWinResults() || GameState.currentRecordHasFreespinWinResults() || GameState.currentRecordHasBonusWinResults();

        return isWin ? Exit.True : Exit.False;
    }
}
